<template>
  <div>
    <h2>jdhfhsdjfhshf</h2>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");

import { mapState } from "vuex";
export default {
  data() {
    return {
      ui_setting: {},
    };
  },
  components: {
   
    ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  },
  created() {
   
  },

  props: {
    // student: {
    //   required: true,
    //   type: Object,
    // },
  },
 
};
</script>
 